<template>
  <div style="min-height: 100vh;">
    <link rel="stylesheet" media="all" type="text/css" href="../../static/front/all.min.css">
    <link rel="stylesheet" media="all" type="text/css" href="../../static/front/style.css">
    <link rel="stylesheet" media="all" type="text/css" href="../../static/front/custom_style.css">
    <router-view name="widgets"></router-view>
  </div>
</template>

<script>
import Vue from 'vue'
import config from '../config/app'
import VueHead from 'vue-head'
Vue.use(VueHead)

export default {
  data () {
    return {
      host: config.host
    }
  }
  // head: {
  //   link: [
  //     {rel: 'stylesheet', href: '/static/front/bootstrap/dist/css/bootstrap.min.css'}
  //   ]
  // }
}
</script>



// WEBPACK FOOTER //
// src/components/WidgetsPanel.vue